import { Directive, forwardRef, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import {
  A11yBooleanInput,
  A11yHasPopupValue,
  A11yLabelTarget
} from '../interfaces/a11y.interfaces';
import { normalizeAriaValue } from '../utils/a11y.util';

import { A11yExpandableDirective } from './a11y-expandable.directive';

@Directive({
  selector: '[khA11yDropdownTrigger]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yDropdownTriggerDirective) }]
})
export class A11yDropdownTriggerDirective extends A11yExpandableDirective implements A11yLabelTarget {
  @Input('khA11yDropdownTrigger') public isOpen: A11yBooleanInput = false;
  @Input() public khA11yDropdownControls: string | null = null;
  @Input() public khA11yDropdownHasPopup: A11yHasPopupValue = 'menu';

  protected override get expandedInput(): A11yBooleanInput {
    return this.isOpen;
  }

  protected override get controlsInput(): string | null {
    return normalizeAriaValue(this.khA11yDropdownControls);
  }

  protected override get hasPopupInput(): A11yHasPopupValue {
    return this.khA11yDropdownHasPopup;
  }

  protected override get hasPopupDefault(): A11yHasPopupValue {
    return 'menu';
  }
}
